import { authApiService } from '@/api/authApiService';
import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';

export const sendVaultAccountConfirmationCodeApi = (id: string): Promise<ApiResponseType<BaseResponseType>> => {
  return authApiService.POST(`/my-vault/accounts/${id}/status/`, {});
};
